const initialState = {
  isProfB2DataLoaded: false,
  alcohol: '',
  methamphetamine: '',
  cocaine: '',
  heroin: '',
  marijuanaHash: '',
  ecstacy: '',
  PCP: '',
  LSDHallucinogens: '',
  inhalants: '',
  prescription: '',
  polyDrugUser: '',
  substanceUseHistoryOther: '',
  substanceUseHistoryComment: '',
  PA2ConcernsNone: '',
  sex: '',
  arson: '',
  violence: '',
  childAbuse: '',
  domesticViolence: '',
  POC: '',
  weapons: '',
  gangs: '',
  enemies: '',
  ADA: '',
  medical: '',
  psychiatric: '',
  victims: '',
  elderAbuse: '',
  PA2ConcernsOthers: '',
  PA2DirectionsNone: '',
  noCoEdProgram: '',
  noContactwithMinors: '',
  noFOTEP: '',
  medicalConcerns: '',
  PA2DirectionsComments: '',
  TIP: '',
  FOTEP: '',
  eligibleTo2933: '',
  inEligibleTo2933: '',
  OSAPAgentsGeneralComments: '',
  dateScreened: '',
  OSAPParoleAgentId: '',
};
export default initialState;
